'use strict';
export default {

    length: function(obj) {
        return typeof obj !== "undefined" && obj != null ? obj.toString().length : 0;
    },

    intEquals: function(a, b) {
        return (typeof a === "undefined" && typeof b === "undefined") || (typeof a !== "undefined" && typeof b !== "undefined" && parseInt(a) === parseInt(b));
    },

    equals: function(a, b) {
        return (typeof a === "undefined" && typeof b === "undefined") || (typeof a !== "undefined" && typeof b !== "undefined" && a.toString() === b.toString());
    },

    intLength: function (obj) {
        return typeof obj !== "undefined" && obj != null && obj.toString().length > 0 ? parseInt(obj) > 0 : 0;
    },

    formatDate: function (e, pattern) {

        if (typeof e === "undefined" || e === null || e.length == 0) return "";

        if (typeof pattern == "undefined" || pattern == null || pattern.length == 0)
            pattern = "dd.MM.yyyy";

        if (e < Date.parse("1970/06/26"))
            e = e * 1000;

        return new Date(e).toString(pattern);

    },

    formatDelivery: function($e) {
        if ($e == null || !/^-?[0-9]+$/.test($e)) {
            return "Info v obchodu";
        }
        else {
            $e = parseInt($e);
            if ($e == 0)
                return "Skladem";
            else if ($e <= 3)
                return "Do 3 dnů"
            else if ($e <= 7)
                return "Do týdne";
            else if ($e <= 14)
                return "Do dvou týdnů";
            else if ($e <= 30)
                return "Do měsíce";
            else
                return "Více než měsíc";
        }
    },

    formatTimestamp: function(e) {
        return this.formatDate(new Date(e * 1000));
    },

    timePassed: function (e) {

        if (typeof e === "undefined" || e === null || e.length == 0) return false;

        var d = typeof e == "string" ? Date.parse(e) : new Date(e);
        var n = new Date();

        var hasTime = d.getHours() != 0 || d.getMinutes() != 0;

        if (hasTime) {
            if (d < n) return true;
            else return false;
        }
        else {
            if (moment(d).isSame(n, "day")) return false;
            else if (d < n) return true;
            else return false;
        }

    },

    timestampTimeago: function(e) {

        if (typeof e === "undefined" || e === null || e.length == 0) return "";

        var d = new Date(e * 1000);

        return d.toString("yyyy-MM-ddTHH:mm:ss") + d.getUTCOffset();

    },

    getTimestamp: function(d) {
        if (typeof d !== "undefined" && d !== null && d.length > 0) {
            return new Date(d).getTime() / 1000;
        }
        return new Date().getTime() / 1000;
    },

    addTimestamp: function(d) {
        if (typeof d !== "undefined" && d !== null) {
            return (new Date().getTime() / 1000) + parseInt(d);
        }
        return new Date().getTime() / 1000;
    },

    formatDateTimeMinutes: function (e, jsTimestamp) {

        if (typeof jsTimestamp == "undefined")
            jsTimestamp = true;

        if (typeof e === "undefined" || e === null || e.length == 0) return "";

        var d = typeof e == "string" ? Date.parse(e) : new Date(e * (jsTimestamp ? 1 : 1000));

        if ((d.getHours() == 0 && d.getMinutes() == 0) || d.getHours() == 23 && d.getMinutes() == 59) {
            return d.toString("dd.MM.yyyy");
        }

        return d.toString("dd.MM.yyyy HH:mm");

    },

    formatDateHuman: function (e, jsTimestamp) {

        if (typeof jsTimestamp == "undefined")
            jsTimestamp = true;

        if (typeof e === "undefined" || e === null || e.length == 0) return "";

        var d = typeof e == "string" ? Date.parse(e) : new Date(e * (jsTimestamp ? 1 : 1000));

        var ad = "";

        if ((new Date().getTime() / 1000) - 31536000 > e) {
            ad = " yyyy";
        }

        return d.toString("dddd dd. MMMM" + ad);

    },

    formatValue: function(type, text) {
        switch (type) {
            case Widgets.TYPES.TEXT:
                return text;
                break;
            case Widgets.TYPES.NUMBER:
                if (typeof text === "undefined")
                    return "0";
                else
                    return text.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1 ');
                break;
            case Widgets.TYPES.LINK:
                if (typeof text !== "undefined" && text.length > 0)
                    return String.format("<a href=\"{0}\" target=\"_blank\">{0}</a>", text);
                break;
            case Widgets.TYPES.DATETIME:
                if (typeof text !== "undefined" && text.length > 0)
                    return TH.formatDateTimeMinutes(text);
                break;
            case Widgets.TYPES.CATEGORY:
                return text;
                break;
            case Widgets.TYPES.FORMATTED_TEXT:
                return text;
                break;
            case Widgets.TYPES.MAP:
                return text;
                break;
            default:
                return text;
                break;
        }
        return "";
    },

    toJsonString: function (o) {
        return JSON.stringify(o);
    },

    parseEmails: function (e) {
        return e.replace(/^(([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?))$/i, "<a href='mailto:$1'>$1</a>");
    },

    formatLinks: function(e) {
        return e.replace(/(https?:\/\/[^\s]+)/g, "<a href='$1' target='_blank'>$1</a>");
    },

    formatDouble: function(n){
        return parseFloat(n).toFixed(2);
    },

    formatMoney: function(n, c, d, t){
        var n = parseInt(n),
            c = isNaN(c = Math.abs(c)) ? 0 : c,
            d = d == undefined ? "," : d,
            t = t == undefined ? " " : t,
            s = n < 0 ? "-" : "",
            i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
            j = (j = i.length) > 3 ? j % 3 : 0;
           return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    },

    formatPrice: function(n, c, d, t){
        var n = parseFloat(n),
            c = isNaN(c = Math.abs(c)) ? 0 : c,
            d = d == undefined ? "," : d,
            t = t == undefined ? " " : t,
            s = n < 0 ? "-" : "",
            i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
            j = (j = i.length) > 3 ? j % 3 : 0;
           return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    },

    and: function() {
        for (var i = 0; i < arguments.length; i++) {
            if (!arguments[i]) return false;
        }
        return true;
    },

    or: function() {
        for (var i = 0; i < arguments.length; i++) {
            if (arguments[i]) return true;
        }
        return false;
    },

    stripHtml: function (html) {
       var tmp = document.createElement("DIV");
       tmp.innerHTML = html.replace(/&amp;/gi, "&");
       return tmp.textContent || tmp.innerText || "";
    },

    maxLength: function(text, max) {
        if (typeof text !== "undefined" && text !== null && text.length > max)
            return text.substr(0, max) + "...";
        return text;
    },

    json: function($data, encode) {
        var s = JSON.stringify($data);
        if (typeof encode === "undefined" || encode)
            s = encodeURI(s);
        return s;
    },

    parseJson: function($string, decode) {
        if (typeof decode === "undefined" || decode)
            $string = decodeURI($string);
        return $.parseJSON($string);
    },

    intoArray: function($o) {
        return Object.keys($o).map(function (key) { return $o[key]; });
    },

    makeLink: function(inputText) {

        if (inputText == null)
            return "";

        var replacedText, replacePattern1, replacePattern2, replacePattern3;

        //URLs starting with http://, https://, or ftp://
        replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

        //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

        //Change email addresses to mailto:: links.
        replacePattern3 = /^([-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?)$/gim;
        replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

        return replacedText;
    },

    makeText: function(inputText) {

        if (inputText == null)
            return "";

        var rp = /(?:\\\n)/g;
        inputText = inputText.replace(rp, "\n");

        rp = /(?:\\\\)/g;
        inputText = inputText.replace(rp, "\\");

        rp = /(?:\r\n|\r|\n|\\n)/g;
        inputText = inputText.replace(rp, "<br />");
        inputText = this.makeLink(inputText);

        return inputText;

    },

    filter: function($array, $fn) {
        if( Object.prototype.toString.call( $array ) === '[object Array]' ) {
            var $out = [];
            for (var $i = 0; $i < $array.length; $i++) {
                if ($fn.call($array[$i])) {
                    $out.push($array[$i]);
                }
            }
            return $out;
        }
        return [];
    },

    group: function($array, $fn) {
        if( Object.prototype.toString.call( $array ) === '[object Array]' ) {
            var $out = [];
            for (var $i = 0; $i < $array.length; $i++) {
                if (v = $fn.call($array[$i]))
                    $out.push(v);
            }
            return $out;
        }
        return [];
    },

    weekday: function($index) {
        switch ($index) {
            case 0:
                return "Po";
            case 1:
                return "Út";
            case 2:
                return "St";
            case 3:
                return "Čt";
            case 4:
                return "Pá";
            case 5:
                return "So";
            case 6:
                return "Ne";
        }
        return "";
    },

    makeid: function($length) {
        if (typeof $length === "undefined")
          $length = 10;
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for( var i=0; i < $length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    },

    getDay: function() {
        var day = new Date().getDay();
        return day > 0 ? day : 7;
    },

    getCookie: function(name, defValue) {
        var $c = $.cookie(name);
        return typeof $c == "undefined" || $c == null ? (typeof defValue !== "undefined" ? defValue : null) : $c;
    },

    limit: function(a, limit) {
        if (typeof a === "undefined" || a === null) return [];
        if( Object.prototype.toString.call(a) === '[object Array]' ) {
            if (a.length > limit) {
                return a.slice(0, limit);
            }
            return a;
        }
        return [];
    },

    adjustWidth: function($oWidth, $oHeight, $nHeight) {
        return Math.round($oWidth * ($nHeight / $oHeight));
    },

    humanFileSize: function(bytes, si) {
        var thresh = si ? 1000 : 1024;
        if(Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        var units = si
            ? ['kB','MB','GB','TB','PB','EB','ZB','YB']
            : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
        var u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while(Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1)+' '+units[u];
    },

    formatMessage: function($message) {

      $message = TH.makeLink($message);
      Object.keys(window.EmojiData.emojis).forEach(function(e) {
        var $u = "<span class='emoji-icon'>" + TH.unifiedToNative(window.EmojiData.emojis[e].unified) + "<span>";
        if (typeof window.EmojiData.emojis[e].emoticons !== "undefined" && window.EmojiData.emojis[e].emoticons.length > 0)
          window.EmojiData.emojis[e].emoticons.forEach(function(em) {
            $message = $message.replace(new RegExp('(\\s|^)(?:' + em.replace(/[-\\()\[\]{}^$*+.?|]/g, '\\$&') + ')(?=\\s|$)', "g"), $u);
          });
        if (typeof window.EmojiData.emojis[e].short_names !== "undefined" && window.EmojiData.emojis[e].short_names.length > 0)
          window.EmojiData.emojis[e].short_names.forEach(function(s) {
            $message = $message.replace(new RegExp('(\\s|^)(?:' + (":"+s+":").replace(/[-\\()\[\]{}^$*+.?|]/g, '\\$&') + ')(?=\\s|$)', "g"), $u);
          });
      });
      return $message;

    },

    unifiedToNative: function(unified) {
      var unicodes = unified.split('-'),
          codePoints = unicodes.map((u) => `0x${u}`);
      return String.fromCodePoint(...codePoints);
    },

    u_atob: function(base64String) {
        if (typeof base64String === "undefined" || base64String === null || base64String === "") return "";
        return decodeURIComponent(Array.prototype.map.call(atob(base64String), function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    },

    u_btoa: function(string) {
      return btoa(encodeURIComponent(string).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
      }));
    },

    copy: function(_i) {
      return JSON.parse(JSON.stringify(_i));
    },

    objectMerge: function (a, b){
      for (var attr in b) { a[attr] = b[attr]; }
      return a;
    }

}
